import { Pipe, PipeTransform } from '@angular/core';
import { Contract } from "../../classes/contract";

@Pipe({
  name: 'contractTitleFilter',
  pure: false
})
export class ContractTitleFilterPipe implements PipeTransform {

  transform(contractList: Array<Contract>, filterValue: string): any {
    if (!contractList || !filterValue) {
      return contractList;
    }
    return contractList.filter(contract => contract.name.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1);
  }

}
